import api from '../api'

export const createFamilyGroupAccess = (params) => api.post('/v1/family-group/user', params)

export const patchFamilyGroupAccessUser = (params, { userId }) => api.patch(`/v1/family-group/user/${ userId }`, params)

export const putFamilyGroupAccessUser = (params, { userId }) => api.put(`/v1/family-group/user/${ userId }/permissions`, params)

export const getFamilyGroupAccess = (params) => api.get('/v1/family-group', { params })
